import React, { useEffect, useRef } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import usePortal from 'react-cool-portal';
import { useUpdateEffect } from 'ahooks';
import { timeline, animate } from 'motion';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';

export const ReactDrawer = ({ parentNode, showDrawer, setShowDrawer, children, className, position, id }) => {
  const wrapperRef = useRef(null);
  const drawerInnerEl = useRef(null);
  const {
    Portal,
    isShow,
    show: showPortal,
    hide: hidePortal,
    toggle: togglePortal,
  } = usePortal({
    defaultShow: false,
    containerId: 'drawers-container',
    autoRemoveContainer: false,
    onShow: (e) => {
      setTimeout(() => {
        animate(wrapperRef.current, { pointerEvents: 'all' });
        let sequence = [
          [wrapperRef.current, { opacity: [0, 1] }],
          // [drawerInnerEl.current, { opacity: [0, 1], transform: 'translateX(0%)' }],
          [drawerInnerEl.current, { opacity: [0, 1], x: 0 }],
          // [drawerInnerEl.current, { opacity: [0, 1], x: [500, 0] }],
        ];
        disableBodyScroll(drawerInnerEl.current);
        document.body.classList.add('drawer-open');
        timeline(sequence);
      }, 100);
    },
    onHide: (e) => {
      animate(wrapperRef.current, { pointerEvents: 'none' });
      clearAllBodyScrollLocks();
      document.body.classList.remove('drawer-open');
    },
  });

  // Bind Esc key to close the modal
  useEffect(() => {
    if (showDrawer) {
      function handleKeyUp(event) {
        switch (event.key) {
          case 'Escape':
            setShowDrawer(false);
            break;
        }
      }
      window.addEventListener('keyup', handleKeyUp);
      return () => window.removeEventListener('keyup', handleKeyUp);
    }
  }, [showDrawer]);

  useUpdateEffect(() => {
    if (showDrawer) {
      showPortal();
    } else {
      let sequence = [
        [drawerInnerEl.current, { x: ['0%', '100%'], opacity: [1, 0] }],
        [wrapperRef.current, { opacity: [1, 0] }],
      ];
      timeline(sequence).finished.then(() => {
        hidePortal();
      });
    }
  }, [showDrawer]);

  return (
    <>
      <Portal>
        <FocusTrap active={showDrawer}>
          <div className={`Drawer ${classNames(className, { 'is-open': showDrawer })}`} ref={wrapperRef}>
            <div
              custom={position}
              className="Drawer__inner"
              ref={drawerInnerEl}
              id={id}
              tabIndex="-1"
              style={position == 'left' ? { left: 0 } : { right: 0 }}
            >
              {children}
            </div>
            <span className="backdrop" onClick={() => setShowDrawer(false)}></span>
          </div>
        </FocusTrap>
      </Portal>
    </>
  );
};
